module.exports = __webpack_public_path__ + "static/media/fossabot-1024.58901940.png";